import {
  BOOK_APPOINTMENT_TIME_SLOT,
  BOOK_APPOINTMENT_TIME_SLOT_SUCCESS,
  REMOVE_CUSTOMER_FROM_WAITING_LIST,
  REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS,
  CONFIRM_BARBER_SUCCESS,
  USER_TOKEN_SUCCESS,
  VERIFY_EMAIL,
  CONFIRM_BARBER,
  VERIFY_PASSWORD,
  VERIFY_PASSWORD_SUCCESS,
  CAMPAIGN_UNSUBSCRIBE,
  CAMPAIGN_UNSUBSCRIBE_SUCCESS,
  CAMPAIGN_UNSUBSCRIBE_ERROR,
} from '../constants';
import { checkStatus, handleRequestError } from '../utils/helpers';
import config from '../../config';

const verifyEmail = url => token => (dispatch) => {
  dispatch({
    type: VERIFY_EMAIL,
    payload: token,
  });

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      emailVerificationToken: token,
    }),
  })
  .then(checkStatus)
  .then(user => dispatch({
    type: USER_TOKEN_SUCCESS,
    payload: `Thank you ${user.firstName}. Your email is successfully verified.`,
  }))
  .catch(handleRequestError(dispatch));
};

export const verifyCustomerEmail = verifyEmail(`${config.url}/customer/verify-email`);

export const verifyBarberEmail = verifyEmail(`${config.url}/barber/verify-email`);

export const confirmBarber = (shopId, barberId) => (dispatch) => {
  dispatch({
    type: CONFIRM_BARBER,
    payload: barberId,
  });

  const url = `${config.url}/shop/${shopId}/confirm/${barberId}`;

  return fetch(url, {
    method: 'POST',
  })
  .then(checkStatus)
  .then(({ message }) => dispatch({
    type: CONFIRM_BARBER_SUCCESS,
    payload: message,
  }))
  .catch(handleRequestError(dispatch));
};

export const resetPassword = (token, password) => (dispatch) => {
  dispatch({
    type: VERIFY_PASSWORD,
    payload: token,
  });

  const url = `${config.url}/user/password-verify`;

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      passwordResetToken: token,
      password,
    }),
  })
  .then(checkStatus)
  .then(() => dispatch({
    type: VERIFY_PASSWORD_SUCCESS,
    payload: 'Password is successfully changed.',
  }))
  .catch(handleRequestError(dispatch));
};

export const bookAppointmentTimeSlot = ({ waitingListCustomerId, waitingListSlotId }) => (dispatch) => {
  dispatch({
    type: BOOK_APPOINTMENT_TIME_SLOT,
  });

  return fetch(`${config.url}/book-appointment-time-slot`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      waitingListCustomerId,
      waitingListSlotId,
      platform: 'Web',
    }),
  })
    .then(checkStatus)
    .then(data => dispatch({
      type: BOOK_APPOINTMENT_TIME_SLOT_SUCCESS,
      payload: data,
    }))
    .catch(handleRequestError(dispatch));
};

export const removeCustomerFromWaitingList = waitingListCustomerId => (dispatch) => {
  dispatch({
    type: REMOVE_CUSTOMER_FROM_WAITING_LIST,
    payload: waitingListCustomerId,
  });

  const url = `${config.url}/customer/waiting-list/${waitingListCustomerId}`;

  return fetch(url, {
    method: 'DELETE',
  })
  .then(checkStatus)
  .then(() => dispatch({
    type: REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS,
    payload: 'Customer is successfully removed from waiting list',
  }))
  .catch(handleRequestError(dispatch));
};

const defaultWLIncludes = ['shop', 'shop.address', 'customer', 'barber', 'services'];
export const fetchCustomerWaitingList = (waitingListCustomerId, includes = defaultWLIncludes) => {
  const params = includes && includes.length ? '?include='.concat((includes || []).join(',')) : '';
  const url = `${config.url}/customer/waiting-list/${waitingListCustomerId}${params}`;
  return fetch(url).then(checkStatus);
};

export const validatePassword = password => fetch(`${config.url}/user/validate-password`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ password }),
}).then(checkStatus)
  .then(({ isValid, feedback }) => {
    if (isValid) return true;
    return Promise.reject(feedback);
  });

export const campaignUnsubscribe = (ownerType, ownerId, customerId) => (dispatch) => {
  dispatch({ type: CAMPAIGN_UNSUBSCRIBE });

  const url = `${config.url}/campaign/unsubscribe/${ownerType}/${ownerId}/${customerId}`;

  return fetch(url, {
    method: 'POST',
  })
  .then(checkStatus)
  .then(() => dispatch({
    type: CAMPAIGN_UNSUBSCRIBE_SUCCESS,
    payload: 'You successfully unsubscribed from future campaign emails.',
  }))
  .catch(err => dispatch({
    type: CAMPAIGN_UNSUBSCRIBE_ERROR,
    payload: err.message,
  }));
};



// WEBPACK FOOTER //
// ./src/app/confirmation/actions.js